/** @format */

import React, { useState } from 'react';
import '../css/StudyMethod.css';

import { FiChevronsUp } from 'react-icons/fi';

import { module1, module2, module3 } from '../utils/studyMethod';

const StudyMethod = () => {
  const [open, setOpen] = useState(1);

  return (
    <section className='StudyMethod' id='study'>
      <div className='study-container container padding'>
        <div className='study-intro'>
          <div className='study-intro-subheading-wrapper'>
            <p className='study-intro-subheading'>
              Temario del curso
            </p>
          </div>
          <h2 className='study-intro-heading'>Dominando ZBrush</h2>
          <p className='study-intro-content'>
            Entrenamiento online con acompañamiento en vivo
          </p>
        </div>
        <div className='study-content'>
          <div className='study-content-item'>
            <div
              className={`study-content-item-head ${
                open === 1 ? 'open' : null
              }`}
              onClick={() => {
                setOpen(1);
              }}>
              <h3 className='study-content-item-heading'>Módulo 1</h3>
              <FiChevronsUp
                className={`study-content-item-icon ${
                  open === 1 ? 'open' : null
                }`}
              />
            </div>
            <div
              className={`study-content-item-content ${
                open === 1 ? 'open' : null
              }`}>
              <ul style={{ width: '100%', margin: 'auto' }}>
                {module1.map((item, index) => (
                  <li
                    key={index}
                    style={{
                      listStyle: 'none',
                    }}>
                    <b style={{ color: '#6000de' }}>
                      {item[0]}:
                    </b>&nbsp;&nbsp;
                    <span>{item[1]}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
          <div className='study-content-item'>
            <div
              className={`study-content-item-head ${
                open === 2 ? 'open' : null
              }`}
              onClick={() => {
                setOpen(2);
              }}>
              <h3 className='study-content-item-heading'>Módulo 2</h3>
              <FiChevronsUp
                className={`study-content-item-icon ${
                  open === 2 ? 'open' : null
                }`}
              />
            </div>
            <div
              className={`study-content-item-content ${
                open === 2 ? 'open' : null
              }`}>
              <ul style={{ width: '100%', margin: 'auto' }}>
                {module2.map((item, index) => (
                  <li
                    key={index}
                    style={{
                      listStyle: 'none',
                    }}>
                    <b style={{ color: '#6000de' }}>
                      {item[0]}:
                    </b>&nbsp;&nbsp;
                    <span>{item[1]}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
        <div className='study-content-item'>
          <div
            className={`study-content-item-head ${
              open === 3 ? 'open' : null
            }`}
            onClick={() => {
              setOpen(3);
            }}>
            <h3 className='study-content-item-heading'>Módulo 3</h3>
            <FiChevronsUp
              className={`study-content-item-icon ${
                open === 3 ? 'open' : null
              }`}
            />
          </div>
          <div
            className={`study-content-item-content ${
              open === 3 ? 'open' : null
            }`}>
            <ul style={{ width: '100%', margin: 'auto' }}>
              {module3.map((item, index) => (
                <li
                  key={index}
                  style={{
                    listStyle: 'none',
                  }}>
                  <b style={{color: '#6000de' }}>
                    {item[0]}:
                  </b>&nbsp;&nbsp;
                  <span>{item[1]}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default StudyMethod;
